module.exports = __webpack_public_path__ + "static/img/chuan.d273a465.png";